<div
  class="flex flex-col bg-purple-100 border-solid border-2 border-purple-300 rounded-2xl relative p-3"
  style="
    background: linear-gradient(
      90deg,
      #ffffff 0%,
      rgba(228, 208, 255, 0.07) 19.9%,
      rgba(202, 162, 255, 0.12) 40.4%,
      rgba(200, 158, 255, 0.06) 69.9%,
      rgba(216, 185, 255, 0.22) 100%
    );
  "
>
  <!-- Desktop Version -->
  <div class="hidden sm:flex w-full items-start gap-4">
    <!-- Avatar -->
    <div class="flex-shrink-0 mx-auto my-auto">
      <div class="hidden sm:block items-center">
        <app-user-profile-picture
          [imageUrl]="publicProfileStore.avatarUrl()"
          [name]="publicProfileStore.displayName()"
          size="xl"
        >
        </app-user-profile-picture>
      </div>
    </div>

    <!-- Name, Verification Icons -->
    <div class="flex-1 flex flex-col justify-center sm:my-auto truncate">
      <div class="flex items-start">
        <div class="flex flex-col gap-0 truncate">
          <h1 class="text-2xl text-bg-main font-bold truncate">
            {{ publicProfileStore.displayName() }}
          </h1>
          <div class="flex items-center gap-2">
            <i
              class="text-text-secondary ph ph-envelope text-2xl"
              matTooltipPosition="above"
              toggleMatTooltip
              matTooltip="{{ 'weHaveVerifiedTheOwnershipOfThisUserEmail' | translate }}"
            >
            </i>
            @for (domain of publicProfileStore.targetDomains(); track domain) {
              <i
                class="text-text-secondary ph ph-globe-simple text-2xl"
                matTooltipPosition="above"
                toggleMatTooltip
                matTooltip="{{
                  'weHaveVerifiedThatThisUserIsTheOwnerOfTheDomain' | translate: { domainName: domain.name }
                }}"
              >
              </i>
            }
            <span id="profile-id" class="text-sm font-semibold text-secondary-text-color">
              {{ publicProfileStore.profileInfo()?.shortId }}
            </span>
          </div>
        </div>
      </div>

      <!-- Action Buttons for Desktop -->
      <div class="hidden sm:flex items-center gap-2 mt-4 sm:mt-3 justify-end sm:justify-start">
        @if (publicProfileStore.showConnectButton()) {
          <app-nicky-button
            [id]="publicProfileStore.alreadyFavorite() ? 'connected' : 'connect'"
            variant="secondary"
            [iconLeft]="publicProfileStore.connectButtonIcon()"
            size="small"
            (click)="handleConnectClick()"
          >
            <span [class.text-green-500]="publicProfileStore.alreadyFavorite()">
              {{
                (publicProfileStore.alreadyFavorite() ? 'public_profile.connected' : 'public_profile.connect')
                  | translate
              }}
            </span>
          </app-nicky-button>
        }

        @if (!publicProfileStore.resumedProfile()) {
          <app-nicky-button
            iconLeft="ph ph-share-network"
            variant="secondary"
            size="medium"
            id="profile-share"
            (click)="openShareModal()"
          >
          </app-nicky-button>
        }

        <app-nicky-button matIconLeft="help-book" variant="secondary" size="medium" (click)="startTour()">
        </app-nicky-button>
      </div>
    </div>
  </div>

  <!-- Mobile Version -->
  <div class="sm:hidden w-full">
    <div class="flex justify-between gap-4">
      <div class="flex gap-4">
        <app-user-profile-picture
          [imageUrl]="publicProfileStore.avatarUrl()"
          [name]="publicProfileStore.displayName()"
          size="lg"
        >
        </app-user-profile-picture>
      </div>

      <div class="flex gap-2">
        <app-nicky-button variant="secondary" matIconLeft="help-book" size="medium" (click)="startTour()">
        </app-nicky-button>

        <app-nicky-button
          iconLeft="ph ph-share-network"
          variant="secondary"
          size="medium"
          id="profile-share"
          (click)="openShareModal()"
        >
        </app-nicky-button>

        @if (publicProfileStore.showConnectButton()) {
          <app-nicky-button
            [id]="publicProfileStore.alreadyFavorite() ? 'connected' : 'connect'"
            variant="secondary"
            [iconLeft]="publicProfileStore.connectButtonIcon()"
            size="medium"
            (click)="handleConnectClick()"
          >
          </app-nicky-button>
        }
      </div>
    </div>

    <div class="space-y-2 ml-1">
      <h1 class="text-xl text-bg-main font-bold mt-5">
        {{ publicProfileStore.displayName() }}
      </h1>
      <div class="flex items-center gap-2">
        <i
          class="text-text-secondary ph ph-envelope text-2xl"
          matTooltipPosition="above"
          toggleMatTooltip
          matTooltip="{{ 'weHaveVerifiedTheOwnershipOfThisUserEmail' | translate }}"
        >
        </i>
        @for (domain of publicProfileStore.targetDomains(); track domain) {
          <i
            class="text-text-secondary ph ph-globe-simple text-2xl"
            matTooltipPosition="above"
            toggleMatTooltip
            matTooltip="{{
              'weHaveVerifiedThatThisUserIsTheOwnerOfTheDomain' | translate: { domainName: domain.name }
            }}"
          >
          </i>
        }
        <span id="profile-id" class="text-sm font-semibold text-secondary-text-color">
          {{ publicProfileStore.profileInfo()?.shortId }}
        </span>
      </div>
    </div>
  </div>
</div>
